// extracted by mini-css-extract-plugin
module.exports = {"brandLogoContainer":"AI","title":"AJ","isLongTitle":"AK"};